import { render, staticRenderFns } from "./custService.vue?vue&type=template&id=5e5be3ec&scoped=true"
import script from "./custService.vue?vue&type=script&lang=js"
export * from "./custService.vue?vue&type=script&lang=js"
import style0 from "./custService.vue?vue&type=style&index=0&id=5e5be3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5be3ec",
  null
  
)

export default component.exports